import { ProxyEvent } from "src/api/adapters/nexus/hooks/useProxyEvents";

const checkIfFilingHasTradeAlert = (id: string, proxyEvents: ProxyEvent[]) => {
  const matchedEvent = proxyEvents.find((proxyEvent) => proxyEvent.id === id);
  return Boolean(matchedEvent && matchedEvent.tradeStats?.recentTrades > 0);
};

export { checkIfFilingHasTradeAlert };
